<template lang="pug">
	b-tabs(:class="`tab-${Layout.settingsTabName}`" v-if="Creative.isSelectedCreativeLoaded()" ref="tabsElement")
		b-tab(v-if="Creative.SelectedCreative.type === 'playable'" v-on:click="tabClick('mraid-sdk')")
			template(slot="title")
				i.main-tab.fa.fa-tasks(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Mraid SDK'}")
			.p-3.mraid-sdk-test
				h6 Mraid SDK test
				div
					small.text-muted Here you can check main Mraid SDK actions. As a rule, they should all be green after you played and clicked on the creative CTA button.
				button.btn.btn-dark(type="submit" v-on:click="openMraidSDKDocs()") MraidSDK docs
				button.btn.btn-dark(type="submit" v-on:click="openMraidSDKSettingsDocs()") Settings docs
				MraidSDK
</template>

<script>

	import Screen 						from './../../mixins/screen';

	import MraidSDK						from "./TabContent/MraidSDK";

	import { Publisher } 				from './../../services/Publisher';
	import { Creative } 					from './../../services/Creative';
	import { Version } 					from './../../services/Version';
	import { Settings } 				from './../../services/Settings';

	export default {
		name: 'TestingContent',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Selected Version Switched", "Selected Creative Fully Loaded", "Update Settings Content", "Selected Version Setting Changed", "Selected Version Tracking Providers Changed"],
			events: {
				"Settings Tab Changed": function() {

					this.$forceUpdate();

					this.$nextTick(() => {

						Broadcast.call("Settings Tab Changed Next Tick");

					});

				},
				"Settings Tab Changed Next Tick,Aside State Opened": function() {

					if (this.$refs.tabsElement) {

						let tabContent = this.$refs.tabsElement.$el.querySelector('.tab-content');

						tabContent.removeEventListener('scroll', this.dispatchScrollEvent);
						tabContent.addEventListener('scroll', this.dispatchScrollEvent);

					}

				}
			}
		},
		components: {
			MraidSDK
		},
		data() {

			this.Creative = Creative;

			this.settings = {};

			return {
				showed: true,
				bannerTab: 'mraid-sdk'
			};

		},
		created() {

			this.collectData();

		},
		methods: {
			collectData() {

				if (!Publisher.SelectedPublisher || !Version.SelectedVersion) return;

				if (!Creative.isSelectedCreativeLoaded()) return;

				let settings = Settings.getVersionSettings(Version.SelectedVersion, false, Creative.SelectedCreative.type === 'end-card');

				//Сортируем все настройки в нужном порядке
				this.settings = _.orderBy(_.values(settings), o => {

					if (o["section_priority"]) return o["section_priority"];

					return 9999;

				});

			},

			setBannerTab(banner_tab) {

				console.log(banner_tab);

				this.bannerTab = banner_tab;

			},
			tabClick(tabName) {

				Layout.setSettingsTab(tabName);

			},

			dispatchScrollEvent() {

				Broadcast.call("Settings Scroll");

			},

			openMraidSDKDocs() {

				Broadcast.call("Show MraidSDK Tutorial");

			},

			openMraidSDKSettingsDocs() {

				Broadcast.call("Show MraidSDK Tutorial Settings");

			}

		},

		mounted() {

		}
	}
</script>

<style lang="sass">

	.mraid-sdk-test

		button
			margin-top: 10px
			margin-right: 20px

</style>
